export default "__VITE_ASSET__DEQiUrGE__"